export const MUAPP = window.MUAPP.scripts || {};


// WEBPACK FOOTER //
// ./src/scripts/src/account/api.js